import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Result } from '@hereisyourgitanton/core';
import { ITradingProcedureService } from '../types/trading-procedure-service';
import { TradingProcedure } from '../../../domain/trading-procedure/models/trading-procedure.model';
import { toTradingProcedure } from '../../auction/mappers/trading-procedure.mapper';
import { TradingProcedureAdminApi } from '@tradgine/data-access/tradgine-data';

@Injectable()
export class TradingProcedureService implements ITradingProcedureService {
    private readonly api: TradingProcedureAdminApi = inject(TradingProcedureAdminApi);

    getTradingProcedures(): Observable<Result<TradingProcedure[], Error>> {
        return this.api.getAll().pipe(
            map((result) =>
                result
                    .map((tps) => tps.map(toTradingProcedure))
                    .mapErr(() => new Error('Failed to fetch auctions'))
            )
        );
    }

    getTradingProcedure(id: number): Observable<Result<TradingProcedure, Error>> {
        return this.api.getById(id).pipe(
            map((result) => result.map(toTradingProcedure))
        );
    }

    delete(id: number): Observable<Result<string, Error>> {
        return this.api.delete(id);
    }

    cancel(id: number): Observable<Result<TradingProcedure, Error>> {
        return this.api.cancel({ tradingProcedureId: id }).pipe(
            map((result) => result.map(toTradingProcedure))
        );
    }
}
